export default __webpack_public_path__ + "static/media/ic-chevron-down.42b5fa3c.svg";